/*
 * A `?redirect=` value is attacker-controllable, so only same-origin paths are
 * honoured. `//evil.example` is protocol-relative and would leave the origin,
 * which is why the second test is not redundant.
 */
export const safeRedirectTarget = (value) =>
    typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') ? value : null;

export default safeRedirectTarget;
